// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff1b1603","453":"4beaf73f","455":"bf57b87c","977":"50559afd"}[chunkId] + ".chunk.js";
};